export function eventTrackingCode(event = "page_view", uniqueId = "") {
  if (import.meta.env.DEV) {
    return;
  }

  // GTM event tracking code
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: `${event}`,
    company_id: `${uniqueId}`,
    virtual_page_location:
      document.location.protocol +
      "//" +
      document.location.hostname +
      document.location.pathname +
      document.location.search,
  });

  // Twitter event tracking code
  if (!window.twq) {
    return;
  }

  window.twq("event", "tw-p0sqo-p0sqq", {
    status: event,
    conversion_id: uniqueId,
  });
}
